export default __webpack_public_path__ + "static/media/imagen01.55a5bf68.jpg";